import React, { Component } from 'react';
import { PromoModalItem } from './'

class PromoModalOffer extends Component {
    render() {
        const { addPromotionPackageToBasket, addPromotionProductToBasket, promotion, network, history } = this.props;

        if( !!promotion[0].package_id ) {
            return (
                <div className="row promo-blocks text-center padding-bottom">
                    <div className="row">
                        <PromoModalItem notOfferLeft={ true } promotion={ promotion } network={ network } history={ history } premium={ true } />
                        <PromoModalItem addToBasket={ packageId => addPromotionPackageToBasket( packageId ) } isOffer={ true } promotion={ promotion } network={ network } history={ history } />
                        <PromoModalItem notOfferRight={ true } promotion={ promotion } network={ network } history={ history } />
                    </div>
                </div>
            );
        } else {
            return (
                <div className="row promo-blocks text-center padding-bottom">
                    <div className="row">
                        <PromoModalItem notOfferLeft={ true } promotion={ promotion } network={ network } history={ history } premium={ true } />
                        <PromoModalItem addToBasket={ productId => addPromotionProductToBasket( productId ) } isOffer={ true } promotion={ promotion } network={ network } history={ history } />
                        <PromoModalItem notOfferRight={ true } promotion={ promotion } network={ network } history={ history } />
                    </div>
                </div>
            );
        }
    };
}

export default PromoModalOffer;



// WEBPACK FOOTER //
// src/client/components/site/features/promos/elements/PromoModalOffer.js